module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-soysauce.628de5da.png";